exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {\n  display: none;\n}\n", ""]);

// exports
